var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.91V15C1 16.5913 1.63214 18.1174 2.75736 19.2426C3.88258 20.3679 5.4087 21 7 21C8.5913 21 10.1174 20.3679 11.2426 19.2426C12.3679 18.1174 13 16.5913 13 15V5C13 3.93913 12.5786 2.92172 11.8284 2.17157C11.0783 1.42143 10.0609 1 9 1C7.93913 1 6.92172 1.42143 6.17157 2.17157C5.42143 2.92172 5 3.93913 5 5V14.182C5 14.4446 5.05173 14.7047 5.15224 14.9474C5.25275 15.19 5.40007 15.4105 5.58579 15.5962C5.7715 15.7819 5.99198 15.9292 6.23463 16.0298C6.47728 16.1303 6.73736 16.182 7 16.182C7.53043 16.182 8.03914 15.9713 8.41421 15.5962C8.78929 15.2211 9 14.7124 9 14.182V7",
    stroke: "#51CDA0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.5a8165255fe35bec4987042ce8253b3d.svg";
export { ForwardRef as ReactComponent };